var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,5.46366667 C23.1295669,5.84683333 22.3960078,5.8595 21.617537,5.48055556 C22.6216361,4.88733333 22.6676172,4.47144444 23.0301194,3.34938889 C22.0912493,3.89933333 21.0507931,4.29938889 19.9440385,4.51577778 C19.0586348,3.58372222 17.794689,3 16.3981465,3 C13.714133,3 11.5391196,5.14911111 11.5391196,7.79644444 C11.5391196,8.17327778 11.5818927,8.53955556 11.664231,8.89 C7.62537872,8.6905 4.04526822,6.77994444 1.64890394,3.87716667 C1.23079665,4.5865 0.990197826,5.41088889 0.990197826,6.29016667 C0.990197826,7.95477778 1.84886829,9.422 3.15237926,10.2822778 C2.35572982,10.2569444 1.60720014,10.0416111 0.951702014,9.68272222 C0.950632686,9.70277778 0.950632686,9.72177778 0.950632686,9.74288889 C0.950632686,12.0672222 2.62626983,14.0052222 4.84940296,14.4464444 C4.13723044,14.6375 3.38656211,14.6670556 2.65407236,14.5287778 C3.27321333,16.4340556 5.06754589,17.8210556 7.19337017,17.8601111 C5.11459633,19.4687778 2.53644627,20.1390556 0,19.8456111 C2.15041882,21.2062222 4.70397434,22 7.44787025,22 C16.3863839,22 21.272144,14.6913333 21.272144,8.35272222 C21.272144,8.14372222 21.268936,7.93894444 21.2593121,7.73205556 C22.2078061,7.0565 23.3487792,6.42633333 24,5.46366667",
    id: "path-vnce1xjofb-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cube-2",
    transform: "translate(-173.000000, -91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cube",
    transform: "translate(69.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Share",
    transform: "translate(44.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    transform: "translate(60.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Circle-Color",
    fill: "#FFFFFF",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-vnce1xjofb-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-vnce1xjofb-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-Color",
    fill: "#051C2C",
    fillRule: "nonzero",
    xlinkHref: "#path-vnce1xjofb-1"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.397647b23c879dfb6db029c4a60b465d.svg";
export { ForwardRef as ReactComponent };